<template>
  <div>
    <div class="drawer-header px-15 pb-0">
      {{bid.order_no}}
      <div class="header-action">
        <Button type="secondary" size="mini" @click="rejectRfq">{{$t('BIDS_WITHDRAW')}}</Button>
        <Button type="primary" size="mini" :disabled="disableSend"
          @click="sendRfq">{{$t('BIDS_SEND')}}</Button>
      </div>
    </div>
    <div class="drawer-body drawer-scroll pt-0">
      <div class="flex-container panel-head align-item-base">
        <div class="flex-item">
          <p>
            {{$t('BIDS_ROUTE')}} :
            <strong>{{getBidRoute}}</strong>
          </p>
          <p v-if="bid.vehicle_type && bid.vehicle_type.short_form">
            {{$t('BIDS_VEHICLE_TYPE')}} :
            <strong>{{hasRequestedVehicle ? requestedVehicle.name : bid.vehicle_type.short_form}}</strong>
          </p>
          <p>
            {{$t('BIDS_FREIGHT_TYPE')}} :
            <strong>{{freightUnit.name}}</strong>
          </p>
          <p v-if="bid.rfqData && bid.rfqData.quote && bid.rfqData.quote.freight_charge && $hasFeature('view_lowest_bid')">
            {{$t('BIDS_LOWEST_BID')}} :
            <strong>{{bid.rfqData.quote.lowest_quote}}</strong>
          </p>
          <p v-if="bid.rfqData && bid.rfqData.quote && bid.rfqData.quote.bid_remarks">
          {{$t('Remarks')}} :
          <strong><Ellipsis :text="bid.rfqData.quote.bid_remarks" :length="80" /></strong>
          </p>
          <p v-if="bid.rfqData.quote.freight_charge > 0 && bid.rfqData.quote.status === 3 && bidDecrement > 0" class="mt-20">
              <strong v-if="decrementType === 'cost'">{{$t('BID_DECREMENT_MESSAGE')}} {{bidDecrement}}</strong>
              <strong v-else>{{$t('BID_DECREMENT_MESSAGE')}} {{getDecrement}}</strong>
          </p>
          <p v-if="bid.transfer_type && $hasFeature('open_indent_details')">
            {{$t('INDENT_FIELD_TRANSFER_TYPE')}} :
            <strong>{{ transferTypeLabel }}</strong>
          </p>
          <p v-if="bid.indent_remarks && $hasFeature('open_indent_details')">
            {{$t('BIDS_REMARKS')}} :
            <strong>{{ bid.indent_remarks }}</strong>
          </p>
        </div>
        <div class="flex-item">
          <p>
            {{$t('INDENT_NO_OF_MATERIALS')}} :
            <strong>{{ getMaterialCount }}</strong>
          </p>
          <p>
            {{$t('INDENT_WEIGHT_KG')}} :
            <strong>{{getMaterialWeight}}</strong>
          </p>
          <p>
            {{$t('INDENT_VOLUME_TYPE') + `(${preferredVolumeUnit})`}} :
            <strong>{{getConvertedClientVolume(getMaterialVolume)}}</strong>
          </p>
        </div>
      </div>
      <div class="mt-15" v-if="bid.rfqData && bid.rfqData.quote && bid.rfqData.quote.shipper_counter_offer">
        <span class="tag-badge bg-danger">Counter: {{  bid.rfqData.quote.shipper_counter_offer }} </span>
      </div>
      <Row>
        <Col :span="20">
          <Form :inline="true" class="form-default form-triple mt-15">
            <div class="form-item-group mb-10">
              <FormItem :label="$t('BIDS_BASE_FREIGHT_RATE')" required>
                <Input type="number" :placeholder="currentClient.currency" v-model="freightRate" @input="checkFreightConflict($event)"/>
              </FormItem>
              <FormItem :label="$t('BIDS_VEHICLE_TYPE')" required>
                <Select
                v-model="selectedVehicleType"
                :placeholder="$t('BIDS_SELECT_VEHICLE_TYPE')"
                class="select-default"
                filterable
                no-data-text="No Data">
                <Option
                  v-for="item in vehicleType"
                  :key="item.id"
                  :label="item.short_form"
                  :value="item.id">
                </Option>
              </Select>
              </FormItem>
              <!-- <FormItem :label="$t('BIDS_FREIGHT_TYPE')" disabled>
                <Input v-model="freightUnit"/>
              </FormItem> -->
              <FormItem :label="$t('BIDS_CEILING_PRICE')" disabled>
                <Input :value="!getCeilingPrice? '-':getCeilingPrice"/>
              </FormItem>
              <!-- <FormItem :label="$t('INDENT_NO_OF_MATERIALS')" disabled>
                <Input v-model="getMaterialCount"/>
              </FormItem>
              <FormItem :label="$t('INDENT_WEIGHT_KG')" disabled>
                <Input v-model="getMaterialWeight"/>
              </FormItem>
              <FormItem :label="$t('INDENT_VOLUME_CFT')" disabled>
                <Input v-model="getMaterialVolume"/>
              </FormItem>
              <FormItem :label="$t('BIDS_QUOTE_REMARKS')" class="full-width">
                <Input type="textarea" :rows="2" size="xsmall" v-model="remarks" :placeholder="$t('BIDS_ENTER_REMARKS')"/>
              </FormItem>-->
            </div>
          </Form>
        </Col>
        <Col :span="20">
          <div class="text-capitalize text-grey_lighter13 text-bold">Note : New Bid should be less than Existing Bid by amount</div>
          <Form :inline="true" class="form-default form-triple mt-10 mb-10">
            <FormItem :label="$t('BIDS_QUOTE_REMARKS')" class="full-width">
                  <Input type="textarea" :rows="2" size="xsmall" v-model="remarks" :placeholder="$t('BIDS_ENTER_REMARKS')"/>
            </FormItem>
          </Form>
        </Col>
      </Row>
      <div class="clearfix mx-pd-15">
        <h5 class="header-stripe">
          <span>{{$t('BIDS_PICKUPS')}}</span>
        </h5>
        <div class="text-sm my-15" v-for="(source,index) in getSourceAddress" :key="index">
          <p><span class="text-bold">{{source.name}}</span></p>
          <p>{{$t('BIDS_ADDRESS')}}: <span class="text-bold">{{getAddress(source)}}</span></p>
        </div>
      </div>
      <div class="clearfix mx-pd-15 bg-grey-lighter">
        <h5 class="header-stripe">
          <span>{{$t('BIDS_DROPOFFS')}}</span>
        </h5>
        <div class="text-sm my-15" v-for="(drop,index) in getDrops" :key="index">
          <p><span class="text-bold">{{drop.address.name}}</span></p>
          <p>{{$t('BIDS_ADDRESS')}}: <span class="text-bold">{{getAddress(drop.address)}}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { contractTypes } from '@/constants/indentConstants';
import { movementType, IndentTransferType } from 'pando-constants';
import getRoute from '@/lib/Route';
import getAddress from '@/lib/Address';
import { get } from 'lodash';
import { mapGetters } from 'vuex';
import VolumeFormulaConvertor from '../../../../../../common-v2/helpers/volume-formula-converter';

export default {
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      freightRate: '',
      contractTypes,
      getAddress,
      vehicleType: [],
      selectedVehicleType: '',
      remarks: '',
      decrementType: '',
      bidDecrement: 0,
      shipperCounterOffer: '',
    };
  },
  async created() {
    this.freightRate = this.bid.rfqData && this.bid.rfqData.quote.freight_charge;
    this.remarks = this.bid.rfqData && this.bid.rfqData.quote.quote_remarks;
    await this.vehicleTypesData();
    let depotId = this.bid.sources[0].location_id;
    if (this.bid.movement === movementType.INWARD || this.bid.movement === movementType.RETURNS) {
      depotId = this.bid.destinations[0].location_id;
    }
    await this.getBidDecrement(depotId, this.bid.movement);
    this.getSelectedVehicleType();
    this.shipperCounterOffer = this.bid.rfqData && this.bid.rfqData.quote && this.bid.rfqData.quote.shipper_counter_offer;
    if (this.shipperCounterOffer) {
      this.freightRate = this.shipperCounterOffer;
    }
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
    }),
    preferredVolumeUnit() {
      return this.$preferredVolumeUnit();
    },
    getDecrement() {
      if (this.decrementType === 'cost') {
        return this.bidDecrement;
      }
      return ((this.bid.rfqData.quote.freight_charge * this.bidDecrement) / 100).toFixed(2);
    },
    getDrops() {
      const resArr = [];
      this.bid.destinations.filter((item) => {
        const i = resArr.findIndex(x => x.location_id === item.location_id);
        if (i <= -1) {
          resArr.push(item);
        }
        return null;
      });
      return resArr;
    },
    getSourceAddress() {
      const resArr = [];
      const visited = [];
      this.bid.sources.filter((item) => {
        let i = 0;
        let isGate = false;
        if (item.gate_id) {
          i = visited.findIndex(x => x.gate_id === item.gate_id);
          isGate = true;
        } else {
          i = visited.findIndex(x => x.location_id === item.location_id);
        }
        if (i <= -1) {
          let sourceAddress = {};
          if (isGate) {
            const gate = item.address && item.address.gates && item.address.gates
            // eslint-disable-next-line no-underscore-dangle
              .find(gateDetail => gateDetail._id === item.gate_id);
            sourceAddress = gate;
          } else {
            sourceAddress = item.address;
          }
          visited.push(item);
          resArr.push(sourceAddress);
        }
        return null;
      });
      return resArr;
    },
    getCeilingPrice() {
      return (this.bid.rfqData && this.bid.rfqData.ceiling_price) || 0;
    },
    getMaterialCount() {
      if (this.bid.rfqData && this.bid.rfqData.no_of_materials) {
        return this.bid.rfqData.no_of_materials;
      }

      if (Array.isArray(this.bid.materials) && this.bid.materials.length > 0) {
        const totalQuantity = this.bid.materials.reduce((sum, mat) => {
          const q =
            mat && mat.quantity && typeof mat.quantity.value === 'number'
              ? mat.quantity.value
              : 0;
          return sum + q;
        }, 0);
        return totalQuantity;
      }
      return 0;
    },
    getMaterialWeight() {
      if (this.bid.rfqData && this.bid.rfqData.material_weight) {
        return this.bid.rfqData.material_weight;
      }

      if (Array.isArray(this.bid.materials) && this.bid.materials.length > 0) {
        const totalWeight = this.bid.materials.reduce((sum, mat) => {
          const w =
            mat && mat.weight && typeof mat.weight.value === 'number'
              ? mat.weight.value
              : 0;
          return sum + w;
        }, 0);
        return totalWeight;
      }

      return 0;
    },
    getMaterialVolume() {
      if (this.bid.rfqData && this.bid.rfqData.material_volume) {
        return this.bid.rfqData.material_volume;
      }

      if (Array.isArray(this.bid.materials) && this.bid.materials.length > 0) {
        const totalVolume = this.bid.materials.reduce((sum, mat) => {
          const v =
            mat && mat.volume && typeof mat.volume.value === 'number'
              ? mat.volume.value
              : 0;
          return sum + v;
        }, 0);
        return totalVolume;
      }

      return 0;
    },
    freightUnit() {
      const currUnit = this.bid.rfqData && this.bid.rfqData.quote.freight_unit;
      return this.contractTypes.find(item => item.id === currUnit);
    },
    disableSend() {
      if (!this.bid.rfqData.quote.freight_charge && !this.freightRate) {
        return true;
      }
      if (this.bid.rfqData.quote.freight_charge > this.freightRate) {
        return this.bid.rfqData.quote.freight_charge - this.freightRate < this.getDecrement || this.freightRate <= 0 || this.selectedVehicleType === '';
      }
      if (this.bid.rfqData.quote.freight_charge === this.freightRate && [this.bid.vehicle_type._id, this.bid.rfqData.quote.vehicle_type_id].includes(this.selectedVehicleType)) {
        return true;
      }
      if ((this.freightRate > 100 || this.freightRate < 0) && this.freightUnit.id === 9) {
        return true;
      }
      return this.freightRate <= 0;
    },
    getBidRoute() {
      const item = getRoute(this.bid.sources, this.bid.destinations);
      let route;
      if (item.tooltipText) {
        route = item.from.concat(' to ', item.tooltipText);
      } else {
        route = item.from.concat(' to ', item.to);
      }
      return route;
    },
    hasRequestedVehicle() {
      return (this.bid.rfqData.requested_vehicle && this.bid.rfqData.requested_vehicle.id);
    },
    requestedVehicle() {
      return this.bid.rfqData.requested_vehicle;
    },
    transferTypeLabel() {
      const transferTypeId = this.bid.transfer_type;
      if (!transferTypeId || !IndentTransferType) {
        return '\u2014';
      }
      const transferTypeMap = {
        [IndentTransferType.REGULAR]: 'TRANSFER_TYPE_REGULAR',
        [IndentTransferType.OUT_OF_METRICS]: 'TRANSFER_TYPE_OUT_OF_METRICS',
        [IndentTransferType.DC_TO_DC]: 'TRANSFER_TYPE_DC_TO_DC',
        [IndentTransferType.DESTRUCTION]: 'TRANSFER_TYPE_DESTRUCTION',
      };
      const translationKey = transferTypeMap[transferTypeId];
      return translationKey ? this.$t(translationKey) : '\u2014';
    },
  },
  methods: {
    checkFreightConflict(val) {
      if (this.freightUnit.id === 9 && val > 100 && val < 0) {
        this.$error({ message: this.$getErr('PER_PERCENTAGE_FREIGHT_LIMIT') });
      }
    },
    getSelectedVehicleType() {
      const selectedVehicleId =
        get(this.bid, 'rfqData.quote.vehicle_type_id') ||
        get(this.bid, 'rfqData.requested_vehicle.id') ||
        get(this.bid, 'vehicle_type._id') ||
        '';
      if (selectedVehicleId) {
        const type = this.vehicleType.find(type => type.id === selectedVehicleId);
        this.selectedVehicleType = type.id;
      }
    },
    sendRfq() {
      const status = 3;
      const lowestQuote = this.bid.rfqData.quote.lowest_quote || 0;
      const leadingBidBufferType = this.leadingBidBufferType;
      const leadingBidBufferValue = this.leadingBidBufferValue || 0;
      if (this.getCeilingPrice === 0 || this.freightRate <= this.getCeilingPrice) {
        if (lowestQuote && leadingBidBufferValue) {
          const { minValue, amountDifference } = this.getMinValue(lowestQuote, leadingBidBufferType, leadingBidBufferValue);
          if (this.freightRate <= lowestQuote && this.freightRate > minValue) {
            const minAmount = lowestQuote - amountDifference;
            const errorMessage = (minAmount > 0) ? `Bid should be less than or equal to ${minAmount}` : 'Bid amount can not be lesser than the lowest bid';
            this.$errorMessage({ message: errorMessage });
            return;
          }
          this.updateRfq(status);
          return;
        }
        this.updateRfq(status);
      } else {
        this.$errorMessage({ message: this.$getErr('CEILING_PRICE_ERROR'), notAutoClosable: true });
      }
    },

    getMinValue(lowestQuote, leadingBidBufferType, leadingBidBufferValue) {
      let amountDifference;
      if (leadingBidBufferType === 'percentage') {
        amountDifference = (((lowestQuote / 100) * leadingBidBufferValue).toFixed(2));
      } else if (leadingBidBufferType === 'cost') {
        amountDifference = leadingBidBufferValue;
      }
      const minValue = lowestQuote - amountDifference;
      return { minValue, amountDifference };
    },

    async vehicleTypesData() {
      const vehicleTypes = await this.$store.dispatch('user/getVehicleTypes', { orderNo: this.bid.order_no });
      this.vehicleType = vehicleTypes.data.map(vehicleType => ({
        id: vehicleType._id,
        short_form: vehicleType.short_form,
      }));
    },
    async rejectRfq() {
      try {
        const rate = this.bid.rfqData && this.bid.rfqData.quote.freight_charge;
        const h = this.$createElement;
        const text = h('div', null, [
          h('span', 'Are you sure you want to withdraw your bid '),
          h('b', rate ? `of Rs.${rate} ` : ''),
          h('span', 'of Indent ID '),
          h('b', `${this.bid.order_no}`),
        ]);
        const hasConfirm = await this.$PromptConfirm(text, 'Withdraw Bid', {
          confirmButtonText: 'Withdraw',
          closeOnClickModal: true,
        });
        if (hasConfirm === 'confirm') {
          const status = 5;
          this.updateRfq(status);
        }
      } catch (error) {
        // log
      }
    },
    async getBidDecrement(depotId, movement) {
      const result = await this.$store.dispatch('indents/bidSettings', {
        depot_id: depotId,
        movement,
      });
      if (result.bid_slot_decrement_configuration) {
        this.decrementType = result.bid_slot_decrement_configuration.type || 'cost';
        this.bidDecrement = result.bid_slot_decrement_configuration.value || 0;
      }
      if (result.leading_bid_buffer_configuration) {
        this.leadingBidBufferType = result.leading_bid_buffer_configuration.type || 'cost';
        this.leadingBidBufferValue = result.leading_bid_buffer_configuration.value || 0;
      }
    },
    updateRfq(status) {
      const data = {
        status,
        ...(this.freightRate) ? { freight_charge: this.freightRate } : null,
      };
      const arrivalSlot = this.bid.rfqData.quote.arrival_at || this.bid.rfqData.loading_date;
      if (arrivalSlot) {
        data.arrival_at = arrivalSlot;
      }
      if (this.selectedVehicleType) {
        data.vehicle_type = this.selectedVehicleType;
      } else {
        data.vehicle_type = '';
      }
      if (this.remarks) {
        data.remarks = this.remarks;
      }
      this.$emit('updateRfq', data);
    },
    getConvertedClientVolume(volume) {
      const volumeInClientUnit = new VolumeFormulaConvertor().revertToClient(this.preferredVolumeUnit, volume);
      return volumeInClientUnit;
    },
  },
};
</script>
